import { render, staticRenderFns } from "./MemoInfo.vue?vue&type=template&id=67267042&scoped=true&"
import script from "./MemoInfo.vue?vue&type=script&lang=js&"
export * from "./MemoInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemoInfo.vue?vue&type=style&index=0&id=67267042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67267042",
  null
  
)

export default component.exports